/**
 * @generated SignedSource<<d089cc34211b82e023e14bd2db245ddf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PointsPoolDisplay_UserFragment$data = {
  readonly extension: {
    readonly pointsInPoolV2?: {
      readonly pointPoolName: string;
      readonly points: number;
    };
  } | null;
  readonly " $fragmentType": "PointsPoolDisplay_UserFragment";
};
export type PointsPoolDisplay_UserFragment$key = {
  readonly " $data"?: PointsPoolDisplay_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PointsPoolDisplay_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PointsPoolDisplay_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "userExtensionKind",
          "value": "InfectopharmUserExtension"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "extension",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limitByDays",
                  "value": 1825
                },
                {
                  "kind": "Literal",
                  "name": "pointPoolId",
                  "value": "UG9pbnRQb29sOmNtZS1wb2ludHM="
                }
              ],
              "concreteType": "CountedPoints",
              "kind": "LinkedField",
              "name": "pointsInPoolV2",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "points",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "pointPoolName",
                  "storageKey": null
                }
              ],
              "storageKey": "pointsInPoolV2(limitByDays:1825,pointPoolId:\"UG9pbnRQb29sOmNtZS1wb2ludHM=\")"
            }
          ],
          "type": "InfectopharmUserExtension",
          "abstractKey": null
        }
      ],
      "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "d526d1833a5892556c10648fd8bf0d95";

export default node;
